/* eslint-disable */
import React, { Component } from 'react';
import axios from 'axios';
import { ROOT_URL_V2 } from '../../../config';
import { Async } from 'react-select';
import 'react-select/dist/react-select.css';
import { connect } from 'react-redux';

class SelectComponent extends Component {
    constructor(props) {
        super(props);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.renderOption = this.renderOption.bind(this);

        this.state = {
            selectedOption: '',
            clients: [],
            isLoading: true,
        };
    }

    componentDidMount() {
        this.getClients();
    }

    componentWillUpdate(nextProps, nextState) {
        const { clientId } = this.props;
        const { clients } = this.state;

        if (
            clientId !== nextProps.clientId ||
            clients.length !== nextState.clients.length
        ) {
            if (nextProps.clientId) {
                const client = nextState.clients.find(
                    item => item.value.id === nextProps.clientId,
                );
                if (client) {
                    this.handleSelectChange(client.value);
                } else {
                    axios({
                        method: 'GET',
                        url: `${ROOT_URL_V2}clients/${nextProps.clientId}/`,
                    }).then(response => {
                        this.setState({
                            selectedOption: {
                                label: response.data.content.company_name,
                                value: response.data.content,
                            },
                        });
                        this.handleSelectChange(response.data.content);
                    });
                }
            }
        }
    }

    getClients(searchTerms = null) {
        let url = `${ROOT_URL_V2}clients/`;
        if (searchTerms) url += `?search=${encodeURIComponent(searchTerms)}`;
        return axios({
            method: 'GET',
            url,
        }).then(response => {
            this.setState({
                clients: response.data.content.map(client => ({
                    label: client.company_name,
                    value: client,
                })),
            });
        });
    }

    handleSelectChange(client) {
        if (client) {
            this.setState({
                selectedOption: {
                    label: client.company_name,
                    value: client,
                },
            });
        } else {
            this.setState({
                selectedOption: '',
            });
        }
        this.props.update(client);
    }

    getOptions = (input, callback) => {
        this.getClients(input)
            .then(() => {
                callback(null, {
                    options: this.state.clients,
                    // CAREFUL! Only set this to true when there are no more options,
                    // or more specific queries will not be sent to the server.
                    complete: true,
                });
            })
            .then(() => {
                this.setState({ isLoading: false });
            });
    };

    renderOption(option) {
        return (
            <div className="client-list-container">
                <img className="client-list-logo" src={option.value.logo} />
                <div className="client-description-container">
                    <div>{option.label} </div>
                    <div>{option.value.email} </div>
                </div>
            </div>
        );
    }

    arrowRender({ onMouseDown, isOpen }) {
        return (
            <div className={`arrow${isOpen ? '' : ' collapsed'}`}>
                <div className="arrow-wrapper">
                    <span className="chevron" />
                </div>
            </div>
        );
    }

    render() {
        const { onStyle } = this.props;
        return (
            <Async
                style={onStyle || {}}
                className={'swiper-no-swiping'}
                disabled={this.props.disabled}
                onChange={this.handleSelectChange}
                options={this.state.clients}
                placeholder={`Select a ${
                    this.props.user.isAgent &&
                    this.props.user.agency.features.includes('booking_tunnel')
                        ? 'Venue'
                        : 'Client'
                }`}
                simpleValue={true}
                value={this.state.selectedOption}
                optionRenderer={this.renderOption}
                arrowRenderer={!this.state.isLoading ? this.arrowRender : null}
                loadOptions={this.getOptions}
                filterOption={() => true}  // removes the default react-select filtering on top of API response
            />
        );
    }
}

const mapStateToProps = state => ({
    user: state.user,
});

export default connect(mapStateToProps)(SelectComponent);
